import { useTranslation } from "react-i18next";

export default function ItemInvoiceFooter() {
  const { t } = useTranslation("general");

  // o-row o-row--horizontal-align_center t-text-mini t-text-align_center
  // border-top: 2px solid #ccc;
  // padding-top: 10px;
  // width: fit-content;
  return (
    <div className="t-text-mini u-width_fit-content u-padding--top_300 u-border--top_1_gray slogan">
      {t("ehsiblySlogan")}
    </div>
  );
}
